/* eslint-disable @next/next/no-img-element */
import { ImageCrop } from 'types/imageCrop';
import { resolveImageBossImage } from './imageBossUrl';

interface Props {
  url: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  imageCrop?: ImageCrop;
}

export function ImageBoss(props: Props) {
  const { url, alt, width, height, className, imageCrop } = props;

  // A height-only request (e.g. the brand logo) caps the rendered height and
  // preserves aspect ratio. Applied regardless of whether the image is served
  // through the ImageBoss CDN so the display size is honored in every env; the
  // CDN rewrites below additionally serve a right-sized image.
  const heightStyle = height && !width ? { maxHeight: `${height}px`, width: 'auto' } : undefined;

  const image = resolveImageBossImage({ url, width, height, imageCrop });
  if (!image) {
    return <img src={url} alt={alt} loading="lazy" className={className} style={heightStyle} />;
  }

  return (
    <img src={image.src} srcSet={image.srcSet} alt={alt} loading="lazy" className={className} style={heightStyle} />
  );
}
